<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="商品管理">
      <template v-if="hasPermission('商品-商品管理-编辑')">
        <el-button
          size="small"
          type="primary"
          @click="updatePurchasePrice"
          icon="el-icon-plus"
          >更新采购价</el-button
        >
      </template>

      <template v-if="hasPermission('商品-商品管理-编辑')">
        <el-button
          size="small"
          type="primary"
          @click="importExcel"
          icon="el-icon-plus"
          >导入EXCEL</el-button
        >
        <el-upload
          ref="upload"
          class="upload-excel"
          :action="uploadAction"
          name="userfile"
          :headers="headers"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :show-file-list="false"
          :on-change="handleChange"
        >
        </el-upload>
      </template>

      <template v-if="hasPermission('商品-商品管理-查看')">
        <el-button
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="exportExcel"
          icon="el-icon-plus"
          >导出EXCEL</el-button
        >
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @ShopIdChange="handleShopIdChange"
    >
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :data="basicListconfig.data"
            resizable
            border
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            :height="basicListconfig.height"
          >
            <el-table-column width="100" prop="class_name" label="商品分类">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品分类"
                  placement="top-start"
                >
                  <span> 商品分类</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="150" prop="item_number" label="商品编码">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品编码"
                  placement="top-start"
                >
                  <span> 商品编码</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              width="300"
              prop="name"
              label="商品名称"
              show-overflow-tooltip
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品名称"
                  placement="top-start"
                >
                  <span> 商品名称</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              width="300"
              prop="item_name_tag"
              label="价签名称"
              show-overflow-tooltip
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="价签名称"
                  placement="top-start"
                >
                  <span>价签名称</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="门店库存" align="center">
              <el-table-column width="100" prop="item_stock_single" label="散">
                <template #header>
                  <el-tooltip effect="dark" content="散" placement="top-start">
                    <span>散</span>
                  </el-tooltip>
                </template></el-table-column
              >
              <el-table-column width="100" prop="item_stock_package" label="箱">
                <template #header>
                  <el-tooltip effect="dark" content="箱" placement="top-start">
                    <span>箱</span>
                  </el-tooltip>
                </template></el-table-column
              >
              <el-table-column width="100" prop="num" label="总">
                <template #header>
                  <el-tooltip effect="dark" content="总" placement="top-start">
                    <span>总</span>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="货值" align="center">
              <el-table-column width="100" prop="avg_price" label="成本价">
                <template #header>
                  <el-tooltip
                    effect="dark"
                    content="成本价"
                    placement="top-start"
                  >
                    <span>成本价</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.avg_price | money }}</template
                >
              </el-table-column>
              <el-table-column width="100" prop="total_price" label="小计">
                <template #header>
                  <el-tooltip
                    effect="dark"
                    content="小计"
                    placement="top-start"
                  >
                    <span>小计</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ (scope.row.avg_price * scope.row.num) | money }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              width="100"
              prop="total_num"
              label="总库存"
              sortable
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="总库存"
                  placement="top-start"
                >
                  <span>总库存</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div
                  class="button button_modify"
                  @click="editShopStockNumButton(scope.row)"
                >
                  {{ scope.row.total_num }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="100"
              prop="item_stock_safe"
              label="安全库存"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="安全库存"
                  placement="top-start"
                >
                  <span>安全库存</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              width="100"
              prop="item_stock_target"
              label="目标库存"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="目标库存"
                  placement="top-start"
                >
                  <span>目标库存</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="100" prop="price_web" label="加盟价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="加盟价"
                  placement="top-start"
                >
                  <span>加盟价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_web | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_instock" label="分销价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="分销价"
                  placement="top-start"
                >
                  <span>分销价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_instock | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_member" label="权限价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="权限价"
                  placement="top-start"
                >
                  <span>权限价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_member | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_outstock" label="批发价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="批发价"
                  placement="top-start"
                >
                  <span>批发价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_outstock | money }}</template
              >
            </el-table-column>

            <el-table-column
              width="100"
              prop="price_distribution"
              label="门店价"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="门店价"
                  placement="top-start"
                >
                  <span>门店价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_distribution | money }}</template
              >
            </el-table-column>

            <el-table-column width="100" prop="price_new" label="采购价">
              <template slot-scope="scope">
                {{ scope.row.price_new | money }}</template
              >
            </el-table-column>
            <el-table-column
              width="180"
              prop="last_buy_time"
              label="采购时间"
            />
            <el-table-column
              width="180"
              prop="last_sell_time"
              label="销售时间"
            />
            <el-table-column width="180" prop="position" label="货架号" />

            <el-table-column
              label="操作"
              width="160"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <template v-if="hasPermission('商品-商品管理-编辑')">
                    <div style="display: flex; align-items: center">
                      <div
                        class="button button_modify"
                        @click="editButton(scope.row)"
                      >
                        <i class="iconfont icon-bianji"></i> 编辑
                      </div>
                    </div>
                  </template>
                  <template>
                    <div
                      class="button button_modify"
                      @click="preview(scope.row, 1)"
                    >
                      <i class="iconfont icon-yulanmoban"></i> 查看
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="table_footer" v-if="basicListconfig.isPage">
            <p class="table_footer_total">
              共{{ basicListconfig.total }}项数据
            </p>
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :page-sizes="[10, 50, 100, 500]"
              :current-page.sync="basicListconfig.searchParameters.page"
              :page-size="basicListconfig.searchParameters.limit"
              layout="sizes,prev, pager, next"
              :total="basicListconfig.total"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <updateProcurement
      :updatePriceObj="updatePriceObj"
      @close="closeupdate"
    ></updateProcurement>

    <shopStockNum
      v-if="shopStockNumDialogParams.visible"
      :dialogParams="shopStockNumDialogParams"
      @close="closeThePopUpWindowShopStockNum"
    ></shopStockNum>
    <!-- 查看详情 -->
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
      width="900px"
    ></previewComponents>
  </div>
</template>


<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { shopStockItemGetlist } from "@/api/product";
import {
  itemClassGetList,
  getshoplist,
  userPermissionShopGetList,
} from "@/api/basicConfiguration";
import { shopStockItemGetOne } from "@/api/product";
import { getRoles } from "@/utils";
import { getSession } from "@/utils/cookie";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "storeProductManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
    // formWindow: () => import("../merchantProductManagement/formWindow.vue"),
    updateProcurement: () =>
      import("../merchantProductManagement/updatePurchasePrice.vue"),
    shopStockNum: () => import("./shopStockNum.vue"),
    previewComponents: () => import("@/components/previewComponents"),
  },
  data() {
    return {
      compId: null,
      shopId: null,
      userId: null,
      roleId: null,

      // 导入文件
      fileList: [], // 用于存储已选择的文件列表
      host: "", // 后端服务地址
      uploadAction: "",
      downloadUrl: "",

      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      shopStockNumDialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      // 列表组件参数
      basicListconfig: {
        table: true,
        height: "calc(100vh - 350px)",
        loading: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            key: "shop_id",
            options: [],
          },
          {
            label: "商品分类",
            type: "treeselect",
            key: "class_id",
            options: [],
          },

          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "上架",
                value: 1,
              },
              {
                label: "下架",
                value: 2,
              },
            ],
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          // {
          //   label: "采购时间",
          //   type: "daterange",
          //   key: "buy_time",
          // },
          // {
          //   label: "销售时间",
          //   type: "daterange",
          //   key: "sell_time",
          // },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      updatePriceObj: {
        key: new Date().getTime(),
        visible: false,
      },
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "purchaseOrder",
        code: "",
        viewObj: [],
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;

    this.headers = {
      "x-token": getSession(),
    };

    switch (process.env.NODE_ENV) {
      // 线上同源
      case "prod":
        this.host = "http://47.100.124.64";
        break;
      // 开发同源
      case "dev":
        this.host = "https://erp.zuizhenshi.cn";
        break;
      // 开发跨域
      case "local":
        this.host = "https://erp.zuizhenshi.cn";
        break;
    }
    // this.host = 'http://106.14.197.16:8080'
    this.uploadAction = this.host + "/admin/shop_stock_item/importExcel";

    // 初始化列表内容
    this.getlist();
    this.obtainDataSource();
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    // 查看事件
    preview(row) {
      this.previewParams.title = "产品详情";
      this.previewParams.code = row.name;
      shopStockItemGetOne({
        comp_id: JSON.parse(getRoles()).comp_id,
        id: row.id,
      }).then((res) => {
        if (res.code == 1) {
          let order_info = res.data[0];
          this.previewParams.viewObj = [
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "商品名称",
                  value: order_info.name,
                },
                {
                  label: "类型",
                  value: order_info.class_name,
                },
                {
                  label: "父类型",
                  value: order_info.class_pname,
                },
                {
                  label: "价签名称",
                  value: order_info.item_name_tag,
                },
                {
                  label: "条码",
                  value: order_info.item_number,
                },
                {
                  label: "内包装虚拟码",
                  value: order_info.inner_virtual_code,
                },
                {
                  label: "外包装虚拟码",
                  value: order_info.outer_virtual_code,
                },
                {
                  label: "安全库存",
                  value: order_info.item_stock_safe,
                },
                {
                  label: "目标库存",
                  value: order_info.item_stock_target,
                },
                {
                  label: "内包装码",
                  value: order_info.inside_number,
                },
                {
                  label: "外包装码",
                  value: order_info.outside_number,
                },
                {
                  label: "单位",
                  value: order_info.type_spec,
                },
                {
                  label: "库存数量",
                  value: order_info.num,
                },
                {
                  label: "件内数量",
                  value: order_info.in_package_num,
                },
                {
                  label: "件数量",
                  value: order_info.item_stock_package,
                },
                {
                  label: "散数量",
                  value: order_info.item_stock_single,
                },
                {
                  label: "有效期",
                  value:
                    (order_info.keep_month
                      ? order_info.keep_month + "月"
                      : "") +
                    (order_info.keep_day ? order_info.keep_day + "日" : ""),
                },
                {
                  label: "最新采购价",
                  value: this.$money(order_info.price_new),
                },
                {
                  label: "分销价",
                  value: this.$money(order_info.price_instock),
                },
                {
                  label: "批发价",
                  value: this.$money(order_info.price_outstock),
                },
                {
                  label: "门店价",
                  value: this.$money(order_info.price_distribution),
                },
                {
                  label: "权限价",
                  value: order_info.price_member,
                },
                {
                  label: "加盟价",
                  value: this.$money(order_info.price_web),
                },
                {
                  label: "最高价",
                  value: this.$money(order_info.max_price),
                },
                {
                  label: "最低价",
                  value: this.$money(order_info.min_price),
                },
                {
                  label: "成本价",
                  value: order_info.avg_price,
                },
                {
                  label: "是否可散补",
                  value: order_info.is_can_singleAdd == 1 ? "是" : "否",
                },
                {
                  label: "商品状态",
                  value: order_info.item_status == 0 ? "上架" : "下架",
                },
              ],
            },
          ];

          this.previewParams.key = new Date().getTime();
          this.previewParams.visible = true;
        } else {
          this.$message.error("获取详情失败");
        }
      });
    },
    updatePurchasePrice() {
      this.updatePriceObj.key = new Date().getTime();
      this.updatePriceObj.visible = true;
    },
    handleShopIdChange(val) {
      this.basicListconfig.searchParameters.shop_id = val;
    },
    exportExcel() {
      let headers = {
        "x-token": getSession(),
      };
      this.downloadUrl = this.host + "/admin/shop_stock_item/exportExcel";

      if (!this.basicListconfig.searchParameters.shop_id) {
        this.basicListconfig.searchParameters.shop_id = this.shopId;
      }
      let shopId = this.basicListconfig.searchParameters.shop_id;

      if (!shopId) {
        this.$message.error("请先选中店面");
        return;
      }
      let url =
        this.downloadUrl + "?comp_id=" + this.compId + "&shop_id=" + shopId;

      axios({
        method: "GET",
        url: url,
        responseType: "blob", // 重要，设置响应类型为blob
        withCredentials: true, // 如果需要携带 cookie
        headers: {
          "x-token": getSession(), // 添加自定义请求头
        },
      })
        .then((response) => {
          // 创建一个新的 Blob 对象，使用响应数据
          const blob = new Blob([response.data]);
          // 为 Blob 生成一个链接
          const downloadUrl = window.URL.createObjectURL(blob);
          // 创建一个临时的 <a> 标签用于下载
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "醉真实-门店商品-导出数据.xlsx"); // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 模拟点击进行下载
          document.body.removeChild(link); // 下载完成后移除元素
          window.URL.revokeObjectURL(downloadUrl); // 释放掉blob对象使用的内存
        })
        .catch((error) => {
          console.error("下载文件失败:", error);
        });
    },
    // 切换上传组件的显示
    importExcel() {
      //this.$refs.upload.handleClick();
      this.$refs.upload.$el.querySelector('input[type="file"]').click();
    },
    // 上传前的处理
    beforeUpload(file) {
      // 检查文件类型
      const isExcel =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isExcel) {
        this.$message.error("只能上传Excel文件");
      }
      return isExcel;
    },
    // 文件上传成功的处理
    handleSuccess(response, file) {
      if (response.code == 1) {
        this.$message.success("文件上传成功");
        this.getlist();
      } else {
        this.$message.error("文件上传失败 " + response.msg);
      }
    },
    // 文件选择改变时的处理
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    closeupdate() {
      this.updatePriceObj.key = new Date().getTime();
      this.updatePriceObj.visible = false;
    },
    handleCurrentChange(val) {
      this.searchEvent(this.searchForm, val, "");
    },
    handleSizeChange(val) {
      this.searchEvent(this.searchForm, "", val);
    },
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认下架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemListLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认上架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemListActive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemListDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 关闭弹窗
    closeThePopUpWindowShopStockNum() {
      this.shopStockNumDialogParams.visible = false;
      this.shopStockNumDialogParams.key = new Date().getTime();
      // this.getlist();
    },
    // 编辑弹窗
    editShopStockNumButton(row) {
      this.shopStockNumDialogParams.key = new Date().getTime();
      this.shopStockNumDialogParams.visible = true;
      this.shopStockNumDialogParams.id = row.item_id;
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.searchParameters.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = this.compId;
      // 默认查本店
      if (!this.basicListconfig.searchParameters.shop_id) {
        this.basicListconfig.searchParameters.shop_id = this.shopId;
      }

      shopStockItemGetlist(this.basicListconfig.searchParameters).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.loading = false;
            this.basicListconfig.data = res.data.map((item) => {
              if (
                item.last_buy_time.substring(0, 4) == "0000" ||
                item.last_buy_time.substring(0, 4) == "1970"
              ) {
                item.last_buy_time = "-";
              }
              if (
                item.last_sell_time.substring(0, 4) == "0000" ||
                item.last_sell_time.substring(0, 4) == "1970"
              ) {
                item.last_sell_time = "-";
              }
              item.name = item.name + "(1*" + item.in_package_num + ")";
              return item;
            });
            this.basicListconfig.total = res.count;
          } else {
            this.basicListconfig.loading = false;
            this.$message.error(res.msg);
          }
        }
      );
    },
    // 获取数据源
    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });

      // 超级用户获取全部店铺
      if (this.roleId != 4) {
        getshoplist({ limit: 10000, status: 0, comp_id: this.compId }).then(
          (res) => {
            if (res.code == 1) {
              this.basicListconfig.search.map((item) => {
                if (item.key == "shop_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });

              // this.storeOptions = res.data.map((item) => {
              //   return {
              //     label: item.name,
              //     value: Number(item.id),
              //   };
              // });
            } else {
              this.$message.error(res.data.msg);
            }
          }
        );
        // 普通用户获取赋权店面
      } else {
        userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("商品-商品管理-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/storeProductManagement/index.vue